import { useId } from "react";
import { DefinitionDescription, DefinitionList, DefinitionTerm } from "@/components/ui/definition-list.tsx";
import useProductReference from "@/features/sub-families/hooks/use-product-reference.ts";
import { useTranslations } from "@/features/translations/components/translations.tsx";
import useCurrentAccessory from "@/services/product/hooks/use-current-accessory.ts";
import useCurrentMountingKit from "@/services/product/hooks/use-current-mounting-kit.ts";
import useCurrentPowerSupply from "@/services/product/hooks/use-current-power-supply.ts";
import useCurrentProduct from "@/services/product/hooks/use-current-product.ts";

export default function IncludedInReference() {
    const t = useTranslations();

    const titleId = useId();

    const currentProduct = useCurrentProduct();
    const productReference = useProductReference();
    const accessory = useCurrentAccessory();
    const mountingKit = useCurrentMountingKit();
    const powerSupply = useCurrentPowerSupply();

    if (!currentProduct) return null;

    return (
        <section className="included-in-reference" aria-labelledby={titleId}>
            <h2 id={titleId} className="included-in-reference__title">
                {t("included_in_reference")}
            </h2>

            <h3 className="included-in-reference__heading">{t("product")}</h3>
            <DefinitionList className="included-in-reference__items">
                <DefinitionTerm>{productReference}</DefinitionTerm>
                <DefinitionDescription>{currentProduct.title}</DefinitionDescription>
                {accessory !== null && (
                    <>
                        <DefinitionTerm className="included-in-reference__preinstalled-code">
                            {accessory.sku}
                        </DefinitionTerm>
                        <DefinitionDescription>
                            {accessory.title} <span className="included-in-reference__badge">{t("preinstalled")}</span>
                        </DefinitionDescription>
                    </>
                )}
            </DefinitionList>

            {(mountingKit !== null || powerSupply !== null) && (
                <>
                    <h3 className="included-in-reference__heading">{t("accessories")}</h3>
                    <DefinitionList className="included-in-reference__items">
                        {mountingKit !== null && (
                            <>
                                <DefinitionTerm>{mountingKit.sku}</DefinitionTerm>
                                <DefinitionDescription>{mountingKit.description}</DefinitionDescription>
                            </>
                        )}
                        {powerSupply !== null && (
                            <>
                                <DefinitionTerm>{powerSupply.sku}</DefinitionTerm>
                                <DefinitionDescription>{powerSupply.product_label}</DefinitionDescription>
                            </>
                        )}
                    </DefinitionList>
                </>
            )}
        </section>
    );
}
